import React, { useContext, useEffect } from 'react';
import { Backdrop as MuiBackdrop, CircularProgress } from "@gti-controls-v2/web-core";
import homePageStyles from "../../common/styles/HomePage";
import { SettingsContext } from '../../providers/settings';

let timer;

const Backdrop = () => {
    const styles = homePageStyles;
    const { isLoading, handleLoading } = useContext(SettingsContext);

    /** Tiempo maximo para esperar UI: 15 segundos */
    useEffect(() => {
        if (isLoading) {
            timer = setTimeout(() => { handleLoading(false); }, 30000);
        } else {
            clearTimeout(timer);
        }
        // eslint-disable-next-line
    }, [isLoading]);

    return (
        <MuiBackdrop sx={styles.backdrop} open={isLoading}>
            <CircularProgress color="inherit" size={60} />
        </MuiBackdrop>
    );
};

export default Backdrop;